<ng-container *ngIf="(currentFixedQuestion$ | async) || (currentCustomerQuestion$ | async)">
    <pmt-question [fixedQuestion]="currentFixedQuestion$ | async" [customerQuestion]="currentCustomerQuestion$ | async" class="root">
    </pmt-question>
</ng-container>
